<!-- Generated template for the TrophyComponent component -->

<div class="trophy-container" #container>
	<div class="trophy-loader">
		<div class="spinner-container">
			<ion-spinner item-start></ion-spinner>
			<p>{{'TROPHY_LOADING_HEADLINE' | translate}}</p>
			<p text-small>{{'TROPHY_LOADING_TEXT' | translate}}</p>
		</div>
	</div>
</div>
<div class="textures">
	<img class="certBg" src='assets/trophy/textures/urkunde3.png' alt='Texture' />
	<img class="lasvegas" src='assets/trophy/textures/lasvegas-medal.png' alt='TextureLV' width="400px" height="300px" />
	<img class = "paris" src="assets/trophy/textures/paris-medal.png" alt="TextureParis" width="400px" height="500px"/>
	<img class="antarctic" src="assets/trophy/textures/antarctic-medal-medal.png" alt="Antarctic"/>
	<img class="greatwall" src="assets/trophy/textures/greatwall-medal.png" alt="Greatwall"/>
	<img class="losangeles" src="assets/trophy/textures/los-angeles.png" alt="LosAngeles"/>
	<img class="newyork" src="assets/trophy/textures/newyork-medal.png" alt="NewYork"/>
	<img class="spooortsLogo" src="assets/trophy/Spooorts_logo_engraved@0.5x.png" alt='Logo' />
	<img class="hannoverLogo" src="assets/trophy/textures/marathon-hannover-logo.png" alt='Logo' />
	<img class="hannoverDate" src="assets/trophy/textures/marathon-hannover-date.png" alt='Date texture' />
	<img class="hannoverTexture" src="assets/trophy/textures/hannover_medal_texture.png" alt='Medal texture' />
</div>